'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage from "./io.intela.sites.digitalinternship.-Page.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_Page$BlogPost(slug) {
  this.fq = null;
  this.fq = slug;
}
export { $c_Lio_intela_sites_digitalinternship_Page$BlogPost as $c_Lio_intela_sites_digitalinternship_Page$BlogPost };
$p = $c_Lio_intela_sites_digitalinternship_Page$BlogPost.prototype = new $j_io$002eintela$002esites$002edigitalinternship$002e$002dPage.$h_Lio_intela_sites_digitalinternship_Page();
$p.constructor = $c_Lio_intela_sites_digitalinternship_Page$BlogPost;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_Page$BlogPost() {
}
export { $h_Lio_intela_sites_digitalinternship_Page$BlogPost as $h_Lio_intela_sites_digitalinternship_Page$BlogPost };
$h_Lio_intela_sites_digitalinternship_Page$BlogPost.prototype = $p;
$p.s = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().W(this, 382963923, true);
});
$p.i = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lio_intela_sites_digitalinternship_Page$BlogPost) && (this.fq === x$0.fq)));
});
$p.t = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().V(this);
});
$p.G = (function() {
  return 1;
});
$p.I = (function() {
  return "BlogPost";
});
$p.H = (function(n) {
  if ((n === 0)) {
    return this.fq;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lio_intela_sites_digitalinternship_Page$BlogPost(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bm)));
}
export { $isArrayOf_Lio_intela_sites_digitalinternship_Page$BlogPost as $isArrayOf_Lio_intela_sites_digitalinternship_Page$BlogPost };
var $d_Lio_intela_sites_digitalinternship_Page$BlogPost = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_Page$BlogPost, "io.intela.sites.digitalinternship.Page$BlogPost", ({
  bm: 1,
  av: 1,
  b: 1,
  e: 1,
  a: 1,
  C: 1
}));
export { $d_Lio_intela_sites_digitalinternship_Page$BlogPost as $d_Lio_intela_sites_digitalinternship_Page$BlogPost };
//# sourceMappingURL=io.intela.sites.digitalinternship.-Page$-Blog-Post.js.map
